export const Focus = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.9985 3.50045L7.05569 2.44326C7.57639 1.92256 8.42061 1.92256 8.94131 2.44326L9.9985 3.50045M3.4985 6.00045L2.44131 7.05764C1.92061 7.57834 1.92061 8.42256 2.44131 8.94326L3.4985 10.0004M12.4985 6.00045L13.5557 7.05764C14.0764 7.57834 14.0764 8.42256 13.5557 8.94326L12.4985 10.0004M9.9985 12.5004L8.94131 13.5576C8.42061 14.0783 7.57639 14.0783 7.05569 13.5576L5.9985 12.5004"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
